import React from 'react';
import Toast from './Toast';

const ToastContainer = ({ 
    toasts = [], 
    onRemoveToast,
    position = 'top-right',
    className = ''
}) => {
    const getPositionClass = () => {
        switch (position) {
            case 'top-left':
                return 'top-4 left-4';
            case 'top-right':
                return 'top-4 right-4';
            case 'top-center':
                return 'top-4 left-1/2 transform -translate-x-1/2';
            case 'bottom-left':
                return 'bottom-4 left-4';
            case 'bottom-right':
                return 'bottom-4 right-4';
            case 'bottom-center':
                return 'bottom-4 left-1/2 transform -translate-x-1/2';
            default:
                return 'top-4 right-4';
        }
    };

    if (toasts.length === 0) return null;

    return (
        <div
            className={`
                fixed z-50 pointer-events-none
                ${getPositionClass()}
                ${className}
            `}
            style={{ width: '100%', maxWidth: '420px' }}
        >
            <div className="pointer-events-auto">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        id={toast.id}
                        type={toast.type}
                        title={toast.title}
                        message={toast.message}
                        duration={toast.duration}
                        onClose={onRemoveToast}
                    />
                ))}
            </div>
        </div>
    );
};

export default ToastContainer;
